@if (includeFileSelector) {
  <mgd-file-selector [hidden]="true" [acceptedTypes]="acceptedFileTypes"
  (selected)="onFileSelectorSelected($event)"></mgd-file-selector>
}
@if (displayActions.length === 1) {
  <button mat-mini-fab class="mat-fab-action" mgdButton
      [matTooltip]="displayActions[0].label" [disabled]="disabled" matTooltipPosition="before" (click)="
        lastIconDisabled ? null : onActionClick($event, displayActions[0])
      ">
    <mat-icon>
      {{ getIcon(displayActions[0]) }}
    </mat-icon>
  </button>
}

@if (displayActions.length > 1) {
  <mat-menu #actionMenu="matMenu" class="mat-action-menu" [overlapTrigger]="false">
    <div matMenuContent (mouseleave)="menuTrigger.closeMenu()">
      @for (action of displayActions; track action) {
        <button mgdButton mat-menu-item [disabled]="action.disabled"
          [matTooltipDisabled]="!action.disabled" [matTooltip]="action.disableTooltip" matTooltipPosition="before"
          (click)="onActionClick($event, action)">
          <mat-icon>
            {{ getIcon(action) }}
          </mat-icon>
          <span>
            {{action.label}}
          </span>
        </button>
      }
    </div>
  </mat-menu>
  <button mat-mini-fab mgdButton class="mat-fab-action" [disabled]="disabled" [matMenuTriggerFor]="actionMenu" (mouseenter)="menuTrigger.openMenu()">
    <mat-icon>menu</mat-icon>
  </button>
}
